// Derive privacy-safe geocodes (Plus Code + H3) from raw coordinates at a given
// precision tier.
//
// Raw coordinates are consumed here and MUST NOT be persisted by callers — only
// the derived Plus Code / H3 cell (at tier) is kept.
import { latLngToCell } from 'h3-js';
import { OpenLocationCode } from 'open-location-code';
// Public → coarse (~5km), Private → ~275m, Premium → ~14m.
export const GEOCODE_TIER = {
    Public: { h3Resolution: 6, plusCodeLength: 6 },
    Private: { h3Resolution: 8, plusCodeLength: 8 },
    Premium: { h3Resolution: 10, plusCodeLength: 10 },
};
/**
 * Derive Plus Code + H3 cell for a coordinate at the given precision tier.
 */
export function deriveGeocode(coords, precision = 'Public') {
    const tier = GEOCODE_TIER[precision];
    const olc = new OpenLocationCode();
    const plusCode = olc.encode(coords.latitude, coords.longitude, tier.plusCodeLength);
    const h3Index = latLngToCell(coords.latitude, coords.longitude, tier.h3Resolution);
    return {
        plusCode,
        plusCodeShort: shortenPlusCode(plusCode),
        h3Index,
        h3Resolution: tier.h3Resolution,
        geocodePrecision: precision,
    };
}
/**
 * Regional short Plus Code: drop the 4-character area prefix. Meaningful only
 * when paired with a locality label (e.g. GeoRef.label).
 */
export function shortenPlusCode(fullCode) {
    if (fullCode.length <= 5)
        return undefined;
    return fullCode.slice(4);
}
//# sourceMappingURL=encode.js.map